<template>
    <div class="container-explain">
        <div>
            <p class="title">
               <img src="../../assets/image/icon2.jpg" alt="">&nbsp;&nbsp;商品兑换流程
            </p>
            <p class="item m-t15">1.兑换成功后进入商城首页“我的-成功订单”-查询商品权益兑换码（兑换码7天有效</p>
            <p class="item">2.通过微信搜索甲子商城公众号并关注--->点击底部特色服务--->9分享兑</p>
            <p class="item">3.输入动卡空间9分享兑串码以获取甲子商城30元代金券</p>
        </div>
        <div class="has-border"></div>
        <div>
            <p class="title">
               <img src="../../assets/image/icon1.jpg" alt="">&nbsp;&nbsp;代金卷使用说明
            </p>
            <p class="item m-t15">1.一个9积分权益兑换甲子商城30元代金券</p>
            <p class="item">2.甲子商城30代金券可在甲子微商城内使用</p>
            <p class="item">3.在甲子微商城订单结算页面可选择使用代金券，结算金额需大于等于代金券金额</p>
            <p class="item">4.订单结算金额扣除代金券抵扣剩余部分请选择其他方式支付</p>
            <p class="item">5.订单取消退还的代金券可再次使用（不含拆分订单）</p>
            <p class="item">6.商品兑换码不折现、不找零、不提供发票</p>
            <p class="item">7.仅支持甲子商城公众号兑换使用</p>
            <p class="item">8.客服热线：<a href="tel:400-777-5560">400-777-5560</a></p>
        </div>
        <div class="gray m-t15">
            <p class="jianjie">公司简介</p>
            <p>北京甲子科技有限责任公司以“尊老.敬老.专注于老年人服务” 为宗旨，是中国专业的老年用品/服务整合提供商。</p>
            <img src="../../assets/image/explain-img.jpg" alt="">
            <p>公司是国家级高新技术企业和科技型中心企业，作为养老企业代表两次登上CCTV2《对话》栏目。</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    }
}
</script>
<style scoped>
.container-explain {
    padding:15px;
    background: #fff;
    font-size:14px;
}
.container-explain img {
    width:16px;
    height:16px;
    border-radius: 50%;
}
.container-explain .title {
    color:#d94648;
    font-size:16px;
    font-weight: 600;
}
.container-explain .item {
    line-height: 1.5;
}
.container-explain .item a {
    color:#d94648;
    font-size:16px;
}
.m-t15 {
    margin-top:15px;
}
.has-border {
    border-bottom:1px solid #d94648;
    margin-top:20px;
    margin-bottom:20px;
}
.gray {
    background: #efecec;
    border-radius: 10px;
    padding:15px 10px;
}
.gray .jianjie {
    text-align: center;
    color:#d94648;
    font-weight: 600;
}
.container-explain .gray img {
    width:100%;
    height:auto;
    border-radius: 0;
    margin:10px 0;
}
</style>